import { api } from "@/api";
import { UpdateBettingMarketMappingParams, BettingMarketMappingDto } from "@/types/ApiResponses/BettingMarket";

export const updateBettingMarketMapping = async (
  params: UpdateBettingMarketMappingParams
): Promise<BettingMarketMappingDto> => {
  const { marketId, id, ...body } = params;
  const res = await api.client.patch(`/betting-markets-new/${marketId}/mappings/${id}`, body);
  return res.data;
};
